import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import { BASE_URL_GQL } from 'src/config';
import { ROUTER_NAME } from 'src/constants';
import { GetAuthorization } from 'src/utils/localStorage';

const httpLink = createHttpLink({
  uri: BASE_URL_GQL
});

const authLink = setContext((_, { headers }) => {
  const authorization = GetAuthorization();
  return {
    headers: {
      ...headers,
      authorization: authorization || 'Basic NWY2YmY1ZjNhYTMxZDRjMzA5NjM0MjAyOmFwcFNlY3JldDE='
    }
  };
});

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    for (let err of graphQLErrors) {
      if (window.location.pathname.includes('/subscription') && err.message.includes('not authorized')) {
        window.location.href = ROUTER_NAME.SUBSCRIPTION_SESSION_EXPIRED + window.location.search;
      }
    }
  }
});

const client = new ApolloClient({
  link: authLink.concat(errorLink).concat(httpLink),
  cache: new InMemoryCache()
});

export default client;
